export class MortgageApplicationNavigationEvents {
  public static readonly AddApplicant = 'ADD_APPLICANT';
  public static readonly DeleteApplicant = 'DELETE_APPLICANT';
  public static readonly ChangeMortgageAppTab = 'CHANGE_MORTGAGE_APP_TAB';
  public static readonly GoToSection = 'GO_TO_SECTION';
}
